import { LinkOutlined, MenuUnfoldOutlined, RobotOutlined } from "@ant-design/icons";
import {
  AutoComplete,
  Badge,
  Button,
  Card,
  Collapse,
  Dropdown,
  Input,
  Menu,
  Modal,
  Popconfirm,
  Spin,
  Switch,
  Table,
  Tag,
  message,
} from "antd";
import React, { useEffect, useState } from "react";

import "./App.less";

const { Search } = Input;
const { Panel } = Collapse;

function onChange(a, b, c) {
  console.log(a, b, c);
}

const STATUS_MAP = {
  1: {
    color: "blue",
    text: "upcoming (early)",
  },
  2: {
    color: "yellow",
    text: "waiting (in class time)",
  },
  3: {
    color: "red",
    text: "missed call (in class time)",
  },
  4: {
    color: "green",
    text: "class is ON (good job!)",
  },
  5: {
    color: "green",
    text: "class is ON (late call)",
  },
  6: {
    color: "red",
    text: "NO call (class was over)",
  },
  7: {
    color: "green",
    text: "class was ON (missed call)",
  },
};

const StatusBadge = (status) => {
  return (
    <Badge color={STATUS_MAP[status].color} text={STATUS_MAP[status].text} />
  );
};

const formatCardName = (username) => {
  const parts = String(username || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length < 2) return parts[0] || "";
  return `${parts[0]}.${parts[parts.length - 1].charAt(0).toUpperCase()}`;
};

const formatStudentCardNames = (students) =>
  (students || [])
    .slice(0, 2)
    .map((student) => formatCardName(student?.username))
    .filter(Boolean)
    .join("&");

const App = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const u = urlParams.get("u");

  let course = urlParams.get("course");

  const [data, setData] = useState([]);
  const [spin, setSpin] = useState(false);
  const [options, setOptions] = useState([]);
  const [userId, setUserId] = useState(u);
  const [iv, setIv] = useState();
  const [renderFirst, setRenderFirst] = useState(true);
  const [tData, setTData] = useState([]);
  const [hiddenData, setHiddenData] = useState(false);
  const [teacherOrStudent, setTeacherOrStudent] = useState(1);
  const [language, setLanguage] = useState("english");
  const [parentEmail, setParentEmail] = useState("");
  const [parentModal, setParentModal] = useState(false);
  const [finduser, setFinduser] = useState({});

  useEffect(() => {
    if (u == undefined) {
      fetch(
        `https://school.thinkland.ai/report/dianpin/api.php?op=get_login_user`,
        {
          mode: "cors",
          credentials: "include",
        },
      ).then((x) =>
        x.json().then((x) => {
          if (x.length != 0) {
            setUserId(x.userid);
          }
        }),
      );
    }
  }, [renderFirst]);

  useEffect(() => {
    const name = iv || finduser?.username;
    document.title = name ? `MyClass - ${name}` : "MyClass";
  }, [iv, finduser?.username]);

  useEffect(() => {
    console.log(userId)
    if (userId != undefined) {
      console.log(userId)
      let url = "";
      if (renderFirst) {
        url = `https://school.thinkland.ai/report/dianpin/api.php?op=find_stu_course&userid=${userId}&courseid=${course}`;
      } else {
        url = `https://school.thinkland.ai/report/dianpin/api.php?op=find_stu_course&userid=${userId}`;
      }

      fetch(url, {
        mode: "cors",
        credentials: "include",
      })
        .then((x) => x.json())
        .then((x) => {
          if (x.error != undefined) {
            window.alert(x.error);
          } else {
            x = x.sort((a, b) => {
              if (
                new Date(a.start_to_end.split("-")[1]) >
                new Date(b.start_to_end.split("-")[1])
              ) {
                return -1;
              } else {
                return 1;
              }
            });

            course = undefined;
            x = x.map((val) => {
              let newstu = val.students.map((stu) => {
                stu.courseid = val.id;
                stu.current_class = val.shortname || val.coursename || "";
                return stu;
              });
              if (val.is_student && val.class_schedule != undefined) {
                let class_index = 1;
                let newschedule = val.class_schedule.map(schedule => {
                  if (schedule.classday > 0) {
                    schedule.index = class_index
                    class_index += 1
                  } else {
                    schedule.index = '-'
                  }
                  return schedule
                })
                val.class_schedule = newschedule;
              }
              val.students = newstu;
              return val;
            });
            console.log(x);

            let c = x.filter((f) => f.course_ended == false);
            if (x.length > 0 && renderFirst) {
              setIv(x[0].username);
            }
            if (c.length == 0) {
              setData(x);
            } else {
              setData(c);
            }
            setTData(x);
            setRenderFirst(false);

            fetch(
              `https://school.thinkland.ai/report/dianpin/api.php?op=find_user&username=${x[0].username}`,
            )
              .then((x) => x.json())
              .then((x) => {
                if (x.error != undefined || x.length == 0) {
                } else {
                  setFinduser(x[0])
                  if (x[0].chinese == false) {
                    setLanguage("english");
                  } else {
                    setLanguage("chinese");
                  }
                }
              });

            if (
              x.some((x) => x.is_student == true) &&
              x.some((x) => x.is_student == false)
            ) {
              setTeacherOrStudent(4);
            } else {
              fetch(
                `https://school.thinkland.ai/report/dianpin/api.php?op=useristeacher&userid=${userId}`,
              )
                .then((vv) => vv.json())
                .then((vv) => {
                  if (vv == true) {
                    if (x.some((x) => x.is_student == true)) {
                      setTeacherOrStudent(4);
                    } else {
                      setTeacherOrStudent(2);
                    }
                  } else {
                    if (x.every((x) => x.is_student == true)) {
                      setTeacherOrStudent(1);
                    } else {
                      setTeacherOrStudent(2);
                    }
                  }
                });
            }
          }
        });

      console.log(userId);
    }
    hiddenFunction(userId);
  }, [userId]);

  let onSearch = (x) => {
    const url = new URL(window.location);
    url.searchParams.delete("u");
    url.searchParams.set("u", userId);
    window.history.pushState({}, "", url);
    if (x != '') {
      fetch(
        `https://school.thinkland.ai/report/dianpin/api.php?op=find_stu_course&userid=${userId}`,
      )
        .then((x) => x.json())
        .then((x) => {
          if (x.error != undefined) {
          } else {
            x = x.sort((a, b) => {
              if (
                new Date(a.start_to_end.split("-")[1]) >
                new Date(b.start_to_end.split("-")[1])
              ) {
                return -1;
              } else {
                return 1;
              }
            });
            x = x.map((val) => {
              let newstu = val.students.map((stu) => {
                stu.courseid = val.id;
                stu.current_class = val.shortname || val.coursename || "";
                return stu;
              });

              if (val.is_student && val.class_schedule != undefined) {
                let class_index = 1;
                let newschedule = val.class_schedule.map(schedule => {
                  if (schedule.classday > 0) {
                    schedule.index = class_index
                    class_index += 1
                  } else {
                    schedule.index = '-'
                  }
                  return schedule
                })
                val.class_schedule = newschedule;
              }
              val.students = newstu;
              return val;
            });
            console.log(x);
            let c = x.filter((f) => f.course_ended == false);
            if (c.length == 0) {
              setData(x);
            } else {
              setData(c);
            }
            setTData(x);
            setHiddenData(false);
            if (
              x.some((x) => x.is_student == true) &&
              x.some((x) => x.is_student == false)
            ) {
              setTeacherOrStudent(4);
            } else {
              fetch(
                `https://school.thinkland.ai/report/dianpin/api.php?op=useristeacher&userid=${userId}`,
              )
                .then((vv) => vv.json())
                .then((vv) => {
                  if (vv == true) {
                    if (x.some((x) => x.is_student == true)) {
                      setTeacherOrStudent(4);
                    } else {
                      setTeacherOrStudent(2);
                    }
                  } else {
                    if (x.every((x) => x.is_student == true)) {
                      setTeacherOrStudent(1);
                    } else {
                      setTeacherOrStudent(2);
                    }
                  }
                });
            }
          }
        });
    }
  };

  let showMoreClick = () => {
    let all = document.querySelectorAll(
      ".outside-panel > .ant-collapse-header[aria-expanded=false]",
    );
    for (let i = 0; i < all.length; ++i) {
      all[i].click();
    }
  };

  let showLessClick = () => {
    let all = document.querySelectorAll(
      ".outside-panel > .ant-collapse-header[aria-expanded=true]",
    );
    for (let i = 0; i < all.length; ++i) {
      all[i].click();
    }
  };

  let onSearchAuto = (x) => {
    if (x == '') {
      setUserId(undefined)
      setData([])
      setTData([])
    }
    fetch(
      `https://school.thinkland.ai/report/dianpin/api.php?op=find_user&username=${x}`,
    )
      .then((x) => x.json())
      .then((x) => {
        if (x.error != undefined) {
        } else {
          setFinduser(x[0])
          if (x[0].chinese == false) {
            setLanguage("english");
          } else {
            setLanguage("chinese");
          }

          setOptions(
            x.map((v) => {
              return {
                label: v.username,
                value: v.username,
                key: v.userid,
              };
            }),
          );
          if (x.length != 0) {
            setUserId(x[0].userid);
          }
        }
      });
  };

  let onSelect = (value, option) => {
    const url = new URL(window.location);
    url.searchParams.set("u", option.key);
    window.history.pushState({}, "", url);
    setUserId(option.key);
    setIv(value);
  };

  let changeSwitch = (checked) => {
    if (checked) {
      showMoreClick();
    } else {
      showLessClick();
    }
  };

  let toDate = (str) => {
    let time = new Date(parseInt(str));
    let year = time.getFullYear();
    let mon = time.getMonth() + 1;
    let day = time.getDate();
    let hour = time.getHours();
    let min = time.getMinutes();
    let sec = time.getSeconds();
    if (mon < 10) mon = "0" + mon;
    if (day < 10) day = "0" + day;
    if (hour < 10) hour = "0" + hour;
    if (min < 10) min = "0" + min;
    if (sec < 10) sec = "0" + sec;
    return `${year}-${mon}-${day}`;
  };

  let checkStudentOrTeacher = (isTeacher = false) => {
    console.log(isTeacher);
    if (isTeacher) {
      let v = 2;
      if (tData.some((x) => x.is_student == true)) {
        v = 4;
      }
      setTeacherOrStudent(v);
    } else {
      console.log(tData);
      if (
        tData.some((x) => x.is_student == true) &&
        tData.some((x) => x.is_student == false)
      ) {
        setTeacherOrStudent(4);
      }
      if (tData.every((x) => x.is_student == false)) {
        setTeacherOrStudent(2);
      }
      if (tData.every((x) => x.is_student == true) || tData.length == 0) {
        setTeacherOrStudent(1);
      }
    }
  };

  let changeData = () => {
    if (hiddenData) {
      let c = tData.filter((f) => f.course_ended == false);
      setData(c);
    } else {
      setData(tData);
    }
    setHiddenData(!hiddenData);
  };

  const sendWeclomeEmail = (courseid, userid) => {
    fetch(`https://school.thinkland.ai/report/dianpin/api.php?op=send_courseinfo_to_user&courseid=${courseid}&userid=${userid}&from=system&action=0`)
      .then(x => x.json())
      .then(x => {
        if (x.error != undefined) {
          window.alert(x.error)
        } else {
          message.success("success")
        }
      })
  }

  let goMyPlan = () => {
    console.log(userId);
    window.open(`https://school.thinkland.ai/myplan/?u=${userId}`, "_blank");
  };
  let hiddenFunction = (x) => {
    const btn = document.querySelector(".ant-input-search-button");
    btn.ondblclick = () => {
      window.open(`https://school.thinkland.ai/user/profile.php?id=${x}`);
    };
  };

  let stuClickEval = (evala, url) => () => {
    if (!evala) {
      window.alert("To be written at the end of the class session.");
    } else {
      window.open(url);
    }
  };

  let retrievePassword = (x) => () => {
    setSpin(true);
    fetch(
      `https://school.thinkland.ai/report/dianpin/api.php?op=retrieve_password`,
      {
        body: `teacher_email=${x.teachers[0].email}&teacher_name=${x.teachers[0].username
          }&coursename=${x.coursename}&courseid=${x.id}&zoominfo=${encodeURIComponent(
            JSON.stringify(x.zoom_info),
          )}`,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      },
    )
      .then((x) => x.json())
      .then((x) => {
        if (x.error != undefined) {
          console.log(x);
        } else {
          setSpin(false);
        }
      });
  };

  let showBindEmail = () => {
    fetch(`https://school.thinkland.ai/report/dianpin/api.php?op=load_user_profile&userid=${userId}&field=CCemail&redirect_url=${window.encodeURIComponent(`https://school.thinkland.ai/${window.location.pathname}${window.location.search}`)
      }`, {
      credentials: "include",
      mode: "cors",
    })
      .then(x => x.json())
      .then(x => {
        if (x.error != undefined) {
          if (x.errorcode == "login_first") {
            Modal.warning({
              title: x.error,
              content: <div>
                You need to log in to do this action.<br />
                Go to <a href="https://school.thinkland.ai/login/index.php" target="_blank">login</a>
              </div>
            });
          } else {
            window.alert(x.error)
          }
        } else {
          setParentModal(true)
          setParentEmail(x.CCemail)
        }
      })

  }

  let handleCreateOrder = (userId, courseId, cateId) => {
    fetch(
      `https://school.thinkland.ai/report/dianpin/classorder.php?op=add_course_order&categoryid=${cateId}&userid=${userId}&courseid=${courseId}&school=0&paystatus=0`,
    )
      .then(x => x.json())
      .then(x => {
        if (x.error != undefined) {
          window.alert(x.error)
        }
      })
  }

  let handleSetParentEmail = () => {
    if (parentEmail != "") {
      fetch(`https://school.thinkland.ai/report/dianpin/api.php?op=save_user_profile`, {
        body: `field=CCemail&userid=${userId
          }&value=${window.encodeURIComponent(parentEmail)}`,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      })
        .then(x => x.json())
        .then(x => {
          if (x.error != undefined) {
            window.alert(x.error)
          } else {
            setParentModal(false)
          }
        })
    }
  }

  const cols = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "-",
      render: (x, o, index) => {
        // 0:no show (absent) 1:正常上课 2:补课 -1:统一停课 -2:班级停课
        if (o.classday === 1) {
          return (
            <span style={{ color: o.currentweek ? "green" : "" }}>
              {o.currentweek ? `This Week ${o.s}` : `class# ${o.s}`}
            </span>
          );
        } else if (o.classday === 0) {
          return <span style={{ color: "red" }}>Class Day(absent)</span>;
        } else if (o.classday === 2) {
          return (
            <span style={{ color: o.currentweek ? "green" : "" }}>
              {o.currentweek ? `(补)This Week ${o.s}` : `(补)# ${o.s}`}
            </span>
          );
        } else {
          return <span>No Class ({o.activity})</span>;
        }
      },
    },
  ];

  const stu_columns = [
    {
      title: "Name",
      dataIndex: "username",
      key: "username",
      render: (t, r) => (
        <a target="_blank" href={`https://thinkland.ai/myclass?u=${r.userid}`}>
          {t}
        </a>
      ),
    },
    {
      title: "Stauts",
      dataIndex: "status",
      key: "status",
      render: (t) => {
        if (t == 0) {
          return <span>Active</span>;
        } else {
          return <span style={{ color: "red" }}>Inactive</span>;
        }
      },
    },
    ,
    {
      title: "Evaluation",
      dataIndex: "evaluation",
      key: "evaluation",
      render: (_, row) => {
        if (row.evaluation == 0) {
          //View
          return (
            <a target="_blank" href={row.evaluation_url}>
              Session Review
            </a>
          );
        } else {
          return (
            <a target="_blank" href={row.evaluation_url}>
              View
            </a>
          );
        }
      },
    },
  ];

  const stu_columns_name_status = [
    {
      title: "Name",
      dataIndex: "username",
      key: "username",
      render: (t, r) => (
        <a target="_blank" href={`https://thinkland.ai/myclass?u=${r.userid}`}>
          {t}
        </a>
      ),
    },
    {
      title: "Stauts",
      dataIndex: "status",
      key: "status",
      render: (t) => {
        if (t == 0) {
          return <span>Active</span>;
        } else {
          return <span style={{ color: "red" }}>Inactive</span>;
        }
      },
    },
  ];

  const stu_end_columns = [
    {
      title: "Name",
      dataIndex: "username",
      key: "username",
      render: (t, r) => (
        <a target="_blank" href={`https://thinkland.ai/myclass?u=${r.userid}`}>
          {t}
        </a>
      ),
    },
    {
      title: "Evaluation",
      dataIndex: "evaluation",
      key: "evaluation",
      render: (_, row) => {
        if (row.evaluation == 0) {
          //View
          return (
            <a target="_blank" href={row.evaluation_url}>
              Session Review
            </a>
          );
        } else {
          return (
            <a target="_blank" href={row.evaluation_url}>
              View
            </a>
          );
        }
      },
    },
    // {
    //   title: 'Evaluation',
    //   dataIndex: 'status',
    //   key: 'status',
    //   render: (t, r) => (
    //     <a target='_blank' href={`https://school.thinkland.ai/teacher/${r.userid}/${r.courseid}`}>
    //       click here
    //     </a>
    //   ),
    // },
    // ,{
    //   title: 'Number',
    //   dataIndex: 'numofclasses',
    //   key: 'numofclasses',
    // }
  ];

  const columns = [
    {
      title: "Class Time",
      dataIndex: "learningtime",
      key: "learningtime",
      render: (x, r, index) => `${index + 1} ${toDate(x + "000")}`,
    },
    {
      title: "Attendance",
      dataIndex: "attendance",
      key: "attendance",
      render: (x) => {
        if (x == "1") {
          return <Badge color="green" text="Attended" />;
        } else if (x == 2) {
          return <Badge color="red" text="Absent" />;
        } else {
          return <Badge color="yellow" text="Tardy" />;
        }
        // // attendance: 1 是否大于0
        // if(x>0){
        //   return <Badge color="green" text="Yes" />
        // }else{
        //   return <Badge color="red" text="No" />
        // }
      },
    },
    {
      title: "Report",
      dataIndex: "videolink",
      key: "videolink",
      render: (x, o) => {
        if (o.id == 0) {
          return (
            <a type="link" href={"#"} style={{ color: "gray" }}>
              Missing
            </a>
          );
        } else {
          return (
            <a
              href={`https://school.thinkland.ai/dianpin/?id=${o.id}`}
              target="_blank"
            >
              click here
            </a>
          );
        }
      },
    },
  ];

  const teacher_columns = [
    {
      title: "Class Time",
      dataIndex: "learningtime",
      key: "learningtime",
      render: (x, r, index) => `${index + 1} ${toDate(x + "000")}`,
    },
    {
      title: "Attendance",
      dataIndex: "attendance",
      key: "attendance",
      render: (x) => {
        // attendance: 1 是否大于0
        if (x == 1) {
          return <Badge color="green" text="Yes(good)" />;
        } else if (x == 0) {
          return <Badge color="red" text="No" />;
        } else if (x == 2) {
          return <Badge color="green" text="Yes(late)" />;
        }
      },
    },
    {
      title: "Report",
      dataIndex: "videolink",
      key: "videolink",
      render: (x, o) => {
        if (o.rid == null) {
          let report = o.report_count.split("/");
          if (Number(report[0]) >= Number(report[1])) {
            return (
              <a type="link" href={"#"} style={{ color: "gray" }}>
                <Badge color="green" text={o.report_count} />
              </a>
            );
          } else {
            return (
              <a type="link" href={"#"} style={{ color: "gray" }}>
                <Badge color="red" text={o.report_count} />
              </a>
            );
          }
        } else {
          return (
            <a
              href={`https://school.thinkland.ai/dianpin/?id=${o.rid}`}
              target="_blank"
            >
              {o.report_count}
            </a>
          );
        }
      },
    },
    {
      title: "Video",
      dataIndex: "video",
      key: "video",
      render: (t) => {
        if (t == null) {
          return (
            <a type="link" href={"#"} style={{ color: "gray" }}>
              watch
            </a>
          );
        } else {
          return (
            <a href={t} target="_blank">
              watch
            </a>
          );
        }
      },
    },
  ];

  const schedule_cols = [{
    title: "Class#",
    dataIndex: "date",
    key: "date",
    render: (x, r, index) => {
      if (r.classday <= 0 && r.attend == 1) {
        return <span style={{ color: "red" }}>{r.index} {r.date}</span>
      } else {
        return <span>{r.index} {r.date}</span>
      }
    },
  }, {
    title: "Attended",
    dataIndex: "attend",
    key: "attend",
    render: (x, r) => {
      if (r.classday > 0 && r.classover > 0) {
        if (r.attend == 1) {
          return <Badge color="green" text="Yes" />;
        } else {
          return <Badge color="red" text="No" />;
        }
      } else if (r.classday > 0 && r.classover == 0) {
        return 'coming'
      } else {
        return r.activity
      }
      // // attendance: 1 是否大于0
      // if(x>0){
      //   return <Badge color="green" text="Yes" />
      // }else{
      //   return <Badge color="red" text="No" />
      // }
    },
  }, {
    title: "Report",
    dataIndex: "videolink",
    key: "videolink",
    render: (x, o) => {
      if (o.classday > 0) {
        if (o.status == 1 && o.reportid > 0) {
          return (<><Badge color="green" text="" /><a
            href={`https://school.thinkland.ai/dianpin/?id=${o.reportid}`}
            target="_blank"
          >
            View
          </a></>)
        } else if (o.status == 2 && o.reportid > 0) {
          return <><Badge color="red" text="" /><a
            href={`https://school.thinkland.ai/dianpin/?id=${o.reportid}`}
            target="_blank"
          >
            Absent
          </a></>
        } else if (o.status == 3 && o.reportid > 0) {
          return (<><Badge color="green" text="" /><a
            href={`https://school.thinkland.ai/dianpin/?id=${o.reportid}`}
            target="_blank"
          >
            Tardy
          </a></>)
        }
      } else if (o.classday <= 0 && o.attend == 1) {
        return <><Badge color="green" text="" /><a
          href={`https://school.thinkland.ai/dianpin/?id=${o.reportid}`}
          target="_blank"
        >
          View
        </a></>
      } else {
        return '-';
      }
    },
  },]

  const scheduleMenu = (
    <Menu>
      <Menu.Item key="0">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`https://school.thinkland.ai/schedule/`}
        >
          student schedule
        </a>
      </Menu.Item>
      <Menu.Item key="1">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`https://school.thinkland.ai/schedule/?t=${userId}`}
        >
          teacher schedule
        </a>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Spin tip="Loading..." spinning={spin}>
        <div
          className="header-container"
          style={{ margin: "0 10px", position: "relative" }}
        >
          <div
            className="header-content"
            style={{ width: "auto", height: "auto" }}
          >
            <div className="header-left" style={{ display: "flex", justifyContent: "space-between" }}>
              <img src="https://school.thinkland.ai/logo.jpg" alt="logo" />
              <Dropdown trigger='click' overlay={
                <Menu>
                  <Menu.Item><a href="https://thinkland.ai/wechat" target="_blank">绑定微信</a></Menu.Item>
                  <Menu.Item onClick={showBindEmail}>家长Email</Menu.Item>
                </Menu>
              }>
                <MenuUnfoldOutlined style={{ fontSize: "20px" }} />
              </Dropdown>
            </div>
            <p style={{ paddingLeft: "10px", background: "#fff" }}>
              {new Date().toString().split("GMT")[0]} ET
            </p>
            <AutoComplete
              dropdownMatchSelectWidth={252}
              options={options}
              onSelect={onSelect}
              value={iv}
              onChange={setIv}
              onSearch={onSearchAuto}
              className="search-input"
            >
              <Search
                placeholder="Enter your name or email"
                allowClear
                enterButton="Search"
                size="large"
                id="search"
                onSearch={onSearch}
              />
            </AutoComplete>
            <br />
          </div>
          <div style={{ marginTop: "10px" }}>
            <div style={{ display: teacherOrStudent != 1 ? "none" : "" }}>
              <span>
                {language == "english"
                  ? `${finduser?.grade || "Student"} Study Plan`
                  : `${finduser?.grade || ""}学习规划(Plan)`}:{" "}
                <a
                  target="_blank"
                  href={`https://school.thinkland.ai/myplan/?u=${userId}`}
                >
                  Link
                </a>
              </span>
              <span style={{ marginLeft: "10px" }}>
                {language == "english" ? "Course List" : "课程列表"}:{" "}
                <a
                  target="_blank"
                  href={`https://school.thinkland.ai/courses/`}
                >
                  Link
                </a>
              </span>
            </div>
            <div style={{ display: teacherOrStudent == 1 ? "none" : "" }}>
              <span>
                Teacher Profile:{" "}
                <a
                  target="_blank"
                  href={`https://school.thinkland.ai/teacher/${userId}`}
                >
                  Link
                </a>
              </span>
              <span style={{ marginLeft: "10px" }}>
                Teaching Signup:{" "}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={
                    finduser?.teaching_availability_url ||
                    `https://docs.google.com/forms/d/e/1FAIpQLSeiHoFeE2o0rmEnIC3tDNb3gSftrV7H_v1JO18bG3xOpMGzrQ/viewform?usp=pp_url&entry.309577089=${encodeURIComponent(
                      finduser?.email || "",
                    )}&entry.902297855=${encodeURIComponent(
                      finduser?.username || "",
                    )}`
                  }
                >
                  Link
                </a>
              </span>
            </div>
            <br />
            <Button
              hidden={data.length == tData.length}
              onClick={changeData}
              style={{ marginLeft: "10px" }}
            >
              {language == "english" ? "Show All Class" : "以往课程(All)"}
            </Button>
            {language == "english" ? "Details" : "下拉显示(Detail)"}
            <Switch
              checkedChildren="On"
              unCheckedChildren="Off"
              defaultChecked
              onChange={changeSwitch}
            />
            <Button
              type="link"
              style={{ display: data.length == 0 ? "" : "none" }}
              href="https://thinkland.ai/en.png"
            >
              Help
            </Button>
            {/* <Button onClick={showMoreClick} style={{ marginLeft: "10px" }}>
            showAll
          </Button>
          <Button onClick={showLessClick} style={{ marginLeft: "10px" }}>
            showLess
          </Button> */}
          </div>
        </div>
        <div style={{ minHeight: "60vh" }}>
          {data.length == 0 && (
            <Card
              key={1}
              style={{ top: "100px" }}
              className="card-container"
              hoverable
            >
              {iv && (
                <div>
                  <Button
                    href={`https://school.thinkland.ai/user/profile.php?id=${userId}`}
                    target="_blank"
                    type="link"
                  >{`${iv}'s Profile`}</Button>
                </div>
              )}
            </Card>
          )}
          {data.map((x, index) => {
            if (x.content || x.content == "") {
              return (
                <Collapse
                  onChange={() => {}}
                  style={{ margin: "20px" }}
                  defaultActiveKey={x.course_ended == false ? ["1"] : ""}
                >
                  <Panel
                    className="outside-panel"
                    header={
                      <p>
                        <strong>{x.shortname}</strong>
                      </p>
                    }
                    key="1"
                  >
                    <Card
                      key={index}
                      title={x.shortname}
                      className="card-container"
                      hoverable
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html: x.content || x.fullname,
                        }}
                      />
                    </Card>
                  </Panel>
                </Collapse>
              );
            } else {
              let teacher = x.teachers.filter((n) => n.roleid == "3")[0];
              let ta = x.teachers.filter((n) => n.roleid == "4")[0];
              const headerName = x.is_student
                ? formatCardName(teacher?.username)
                : formatStudentCardNames(x.students);
              let xcz = 1;
              const classCalendar = [];
              x.class_calendar.map((x) => {
                if (x.classday > 0) {
                  x.s = xcz;
                  xcz++;
                }
              });

              return (
                <Collapse
                  onChange={() => {}}
                  style={{ margin: "20px" }}
                  defaultActiveKey={["1"]}
                >
                  <Panel
                    className={teacher == undefined ? "" : "outside-panel"}
                    header={
                      <p>
                        {
                          x.class_notify == 0 ? <Popconfirm
                            title="Are you sure to send Email?"
                            onConfirm={() => { sendWeclomeEmail(x.id, x.userid) }}
                            okText="Yes"
                            cancelText="No"
                          ><span style={{ verticalAlign: "middle", color: "orange" }}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bell-fill" viewBox="0 0 16 16">
                                <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2m.995-14.901a1 1 0 1 0-1.99 0A5 5 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901" />
                              </svg>
                            </span></Popconfirm> : ""
                        }
                        <strong>
                          {x.year_title} {x.coursename} - {x.students.length == 0 ? '0 Student' : `【${x.attend_info.length}/${x.numofclasses}】`}
                          {headerName ? ` ${headerName}` : ""}
                        </strong>
                        {x.is_student && x.paystatus != "Paid" && x.course_ended == false && (
                          x.paystatus == '' ? (
                            x.isadmin ? (
                              <Popconfirm
                                title="Are you sure Add Order?"
                                onConfirm={() => { handleCreateOrder(x.userid, x.id, x.category) }}
                                okText="Yes"
                                cancelText="No"
                              >
                                <Button type="link" size="small" style={{ marginLeft: "8px" }}>Add Order</Button>
                              </Popconfirm>
                            ) : (
                              <Tag color="warning" style={{ marginLeft: "8px" }}>No Order</Tag>
                            )
                          ) : (
                            x.paystatus == "Unpaid" ? (
                              <Tag color="error" style={{ marginLeft: "8px" }}>
                                <a target="_blank" href={`https://school.thinkland.ai/classorder/${x.userid}`} style={{ color: "inherit" }}>
                                  {x.paystatus}
                                </a>
                              </Tag>
                            ) : x.paystatus == "UnConfirmed" ? (
                              <Tag color="warning" style={{ marginLeft: "8px" }}>
                                <a target="_blank" href={`https://school.thinkland.ai/classorder/${x.userid}`} style={{ color: "inherit" }}>
                                  To Be Confirmed
                                </a>
                              </Tag>
                            ) : null
                          )
                        )}
                      </p>
                    }
                    key="1"
                  >
                    <Card
                      key={index}
                      title={
                        <a
                          style={{
                            color: x.course_ended == false ? "#000" : "gray",
                          }}
                          target="_blank"
                          rel="noopener noreferrer"
                          href={x.is_student
                            ? `https://school.thinkland.ai/course/view.php?id=${x.id}`
                            : `https://school.thinkland.ai/user/index.php?id=${x.id}`}
                        >
                          <LinkOutlined style={{ marginRight: "6px" }} />
                          {x.coursename}
                        </a>
                      }
                      className="card-container"
                      hoverable
                    >
                      {x.today_class_daytime != "" && (
                        <p>
                          <span>Today's Class: </span>
                          <a
                            href={`/classinfo?course=${x.id}`}
                            target="_blank"
                            style={{ color: "blue" }}
                          >
                            {x.today_class_daytime}
                          </a>
                        </p>
                      )}
                      <p>
                        <span>Teacher: </span>
                        {teacher == undefined ? (
                          ""
                        ) : (
                          <b>
                            <a
                              style={{ color: "#000" }}
                              target="_blank"
                              href={`https://school.thinkland.ai/teacher/${teacher.id}`}
                            >
                              {teacher.username}
                            </a>
                          </b>
                        )}{" "}
                        {teacher == undefined || (teacher.email == "" && teacher.discord == "") ? "" : (
                          <span>
                            ({teacher.email != "" && (
                              <a href={`mailto:${teacher.email}`} style={{ marginRight: "10px" }}>
                                Email
                              </a>
                            )}
                            {teacher.email != "" && teacher.discord != "" && "| "}
                            {teacher.discord != "" && (
                              <a href={`https://discord.com/users/${teacher.discord}`} target="_blank">
                                Discord
                              </a>
                            )})
                          </span>
                        )}
                      </p>
                      {ta != undefined && (
                        <p>
                          <span>TA: </span>
                          {ta == undefined ? "" : ta.username}
                        </p>
                      )}
                      {x.course_ended == false && (
                        <p>
                          <span>Class meeting: </span>
                          {x.zoom_info == undefined ? (
                            ""
                          ) : (
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href={`https://school.thinkland.ai/meet/?course=${x.id}`}
                            >
                              Click HERE to join the class
                            </a>
                          )}
                        </p>
                      )}
                      {x.course_ended == false &&
                        x.zoom_info &&
                        (x.is_student == true ? (
                          <p>
                            <span>Meeting ID: </span>
                            <span style={{ textDecoration: "line-through" }}>
                              {x.zoom_info.zoom_id} ({x.zoom_info.zoom_code})
                            </span>
                          </p>
                        ) : (
                          <p>
                            <span>Zoom ID: </span>
                            <span style={{ textDecoration: "line-through" }}>
                              {x.zoom_info.zoom_account}{" "}
                              <Button
                                type="link"
                                style={{ textDecoration: "line-through" }}
                                onClick={retrievePassword(x)}
                              >
                                <span style={{ textDecoration: "line-through" }}>
                                  Retrieve Password
                                </span>
                              </Button>
                            </span>
                          </p>
                        ))}
                      {/* {x.course_ended == false && (x.is_student == true ? undefined : <p><span>Password: </span>******</p>)} */}
                      <p>
                        <span>Class Start & End: </span>
                        {x.start_to_end}
                        {x.is_student && x.paystatus == "Paid" && (
                          <>
                            <a target="_blank" href={`https://school.thinkland.ai/classorder/${x.userid}`} style={{ marginLeft: "10px" }}>
                              {x.paystatus}
                            </a>
                            <Popconfirm
                              title={`Are you sure to send Receipt to ${x.username}?`}
                              onConfirm={() => {
                                fetch(`https://school.thinkland.ai/report/dianpin/api.php?op=send_receipt&courseid=${x.id}&userid=${x.userid}`)
                                  .then(x => x.json())
                                  .then(x => {
                                    if (x.error == undefined) {
                                      window.alert("Payment receipt is sent. Please check your email.")
                                    } else {
                                      window.alert(x.error)
                                    }
                                  })
                              }}
                              okText="Yes"
                            >
                              <Button type="link">Receipt</Button>
                            </Popconfirm>
                          </>
                        )}
                      </p>

                      {/* <p><span>Class Start Date: </span>{x.startdate}</p> */}
                      <Collapse onChange={() => {}}>
                        <Panel
                          header={
                            <p>
                              <span>Class Calendar </span>({x.numofclasses})
                            </p>
                          }
                          key="1"
                        >
                          <div
                            style={{
                              height: "360px",
                              overflow: "hidden",
                              overflowY: "scroll",
                            }}
                          >
                            <Table
                              dataSource={x.class_calendar}
                              columns={cols}
                              pagination={false}
                            />
                          </div>
                        </Panel>
                      </Collapse>
                      {x.course_ended == false && (
                      <p>
                        <span>Next Class: </span>
                        {x.next_class_time}
                      </p>
                      )}
                      {x.is_student != true && x.course_ended == false && (
                        <p>
                          <span>Today's Class Status: </span>
                          <a href={`/classinfo?course=${x.id}`} target="_blank">
                            {x.classtoday == 0
                              ? "None"
                              : StatusBadge(x.classstatus)}
                          </a>
                        </p>
                      )}
                      {x.is_student == true && x.course_ended == false && (
                        <p>
                          <span>Leave of Absence request: </span>
                          <a
                            target="_blank"
                            href={`https://docs.google.com/forms/d/e/1FAIpQLSf2GJyyK2Qufn0mUV0kfUCa14WABy-GxBnsHt3-5IoywHGHMg/viewform?usp=pp_url&entry.487964997=${encodeURIComponent(
                              x.email,
                            )}&entry.984460682=${encodeURIComponent(
                              x.username,
                            )}&entry.2010423503=${encodeURIComponent(
                              x.idnumber,
                            )}&entry.1254092224=${encodeURIComponent(
                              x.timetitle,
                            )}&entry.1310420551=${x.teachers[0] == undefined
                              ? ""
                              : encodeURIComponent(x.teachers[0].username)
                              }&entry.641588117=${x.teachers[0] == undefined
                                ? ""
                                : encodeURIComponent(x.teachers[0].email)
                              }`}
                          >
                            Click HERE to submit
                          </a>
                        </p>
                      )}
                      {x.is_student != true && x.course_ended == false && (
                        <p>
                          <span>Class change request link: </span>
                          <a
                            target="_blank"
                            href={`https://docs.google.com/forms/d/e/1FAIpQLSdr0KBGJsv2r8HI4kZXHvlhiNjU6GkL4n8IMEmxMdPnjen3AA/viewform?usp=pp_url&entry.1759783182=${encodeURIComponent(
                              teacher.email,
                            )}&entry.984460682=${encodeURIComponent(
                              teacher.username,
                            )}&entry.2010423503=${encodeURIComponent(
                              x.shortname,
                            )}&entry.1254092224=${encodeURIComponent(
                              x.timetitle,
                            )}`}
                          >
                            Click HERE to submit
                          </a>
                        </p>
                      )}
                      {/* {x.is_student == true && <p><span>Teacher No-Show: </span>  <Popconfirm
                  title="Are you sure to report teacher no-show?"
                  onConfirm={teacherReport(`https://school.thinkland.ai/report/dianpin/notify.php?userid=${x.userid}&courseid=${x.id}&reporttype=1`, x.start_class)}
                  onCancel={() => { }}
                  okText="Yes"
                  cancelText="No"
                ><Button>Click to report</Button>
                </Popconfirm></p>} */}
                      {/* {x.course_ended==false &&(x.is_student == true && <p><span>Student Can't-attend: </span>
                  <Popconfirm
                    title="Are you sure to submit student can't-attend?"
                    onConfirm={attendReport(`https://school.thinkland.ai/report/dianpin/notify.php?userid=${x.userid}&courseid=${x.id}&reporttype=2`)}
                    onCancel={() => { }}
                    okText="Yes"
                    cancelText="No"
                  ><Button>Click to submit</Button></Popconfirm></p>)} */}
                      {!x.is_student && (
                        <Collapse>
                          <Panel
                            header={`Students (${x.students.filter((val) => val.status == 0).length
                              })`}
                            key="1"
                          >
                            {x.course_ended ? (
                              <Table
                                dataSource={x.students}
                                columns={stu_end_columns}
                                pagination={false}
                              />
                            ) : (x.numofclasses - (x.attend_info?.length ?? 0) <= 3 ? (
                              <Table
                                dataSource={x.students}
                                columns={stu_columns}
                                pagination={false}
                              />
                            ) : (
                              <Table
                                dataSource={x.students}
                                columns={stu_columns_name_status}
                                pagination={false}
                              />
                            ))}
                          </Panel>
                        </Collapse>
                      )}
                      {!x.is_student && (
                        <Collapse onChange={() => {}}>
                          <Panel
                            header={
                              <p>
                                <span>Class Reports</span>
                                <span style={{ color: "#9c0006", marginLeft: "10px" }}>
                                  {x.attend_info.some(
                                    (item) =>
                                      item.attendance == "0" ||
                                      item.miss_report != "0",
                                  )
                                    ? `Miss：Attend-${x.attend_info.filter(vv => vv.attendance == '0').length}/Report-${x.attend_info.map(f => f.miss_report).reduce((prev, curr) => prev + curr)}`
                                    : x.attend_info.length}
                                </span>
                              </p>
                            }
                            key="1"
                          >
                            <Table
                              dataSource={x.attend_info}
                              columns={x.is_student ? columns : teacher_columns}
                              pagination={false}
                            />
                          </Panel>
                        </Collapse>
                      )}

                      {x.is_student && (
                        <Collapse onChange={() => {}}>
                          <Panel
                            header={`Class Reports - ${x.attend_info.length} (Click to view)`}
                            key="1"
                          >
                            <Table
                              dataSource={x.attend_info}
                              columns={x.is_student ? columns : teacher_columns}
                              pagination={false}
                            />
                          </Panel>
                        </Collapse>)}

                      {x.is_student ? (
                        <p>
                          <span>Teacher's </span>
                          <a
                            target="_blank"
                            onClick={stuClickEval(x.evaluation, x.evaluation_url)}
                          >
                            Evaluation & Recommendation
                          </a>
                        </p>
                      ) : (
                        <p>
                          <span>Feedback for student: </span>
                          {x.students.map((student, index) => {
                            const feedbackUrl = `https://docs.google.com/forms/d/e/1FAIpQLSftrkfVm13Up4QNQF49dkfZwZG4Pkny_z_M0RHBUY2JGWUo8A/viewform?usp=pp_url&entry.2027209253=${encodeURIComponent(teacher?.email || "")}&entry.123317474=${encodeURIComponent(teacher?.username || "")}&entry.1369653140=${encodeURIComponent(student?.username || "")}&entry.819729163=${encodeURIComponent(x.shortname || x.coursename || "")}`;
                            return (
                              <span key={student.userid}>
                                <a target="_blank" href={feedbackUrl}>
                                  {student.username}
                                </a>
                                {index < x.students.length - 1 ? ", " : ""}
                              </span>
                            );
                          })}
                        </p>
                      )}

                      {x.is_student && (
                        <Collapse onChange={() => {}}>
                          <Panel
                            header={
                              <p>
                                <span>Class Schedule - </span>
                                <span>
                                  {x.attend_count} {x.miss_count == 0 ? '' : `+${x.miss_count} Miss`}/{x.numofclasses} (Click to view)
                                </span>
                              </p>
                            }
                            key="1"
                          >
                            <Table
                              dataSource={x.class_schedule}
                              columns={schedule_cols}
                              pagination={false}
                            />
                          </Panel>
                        </Collapse>
                      )}
                      {x.is_student && x.teachers && x.teachers.length > 0 && (
                        <p>
                          <span>Feedback for teacher: </span>
                          {x.teachers.map((t, index) => (
                            <span key={t.id}>
                              <a
                                target="_blank"
                                href={`https://school.thinkland.ai/teacher/review_invite.html?courseid=${x.id}&teacherid=${t.id}&userid=${x.userid}`}
                              >
                                {t.username}{t.roleid == "4" ? " (TA)" : ""}
                              </a>
                              {index < x.teachers.length - 1 ? ", " : ""}
                            </span>
                          ))}
                        </p>
                      )}
                    </Card>
                  </Panel>
                </Collapse>
              );
            }
          })}

          <Modal title="Set Email" visible={parentModal} okText="Submit" onOk={handleSetParentEmail} onCancel={() => {
            setParentModal(false)
          }}>
{finduser != undefined &&             <div>
              <span><b>{finduser.username}</b></span>: <span>{finduser.email}</span>
            </div>}
            <div style={{ marginTop: "10px" }}>
              <span style={{ marginRight: "20px" }}>
                <b>CC Email</b>(多邮箱用逗号","分割)：
              </span>
            </div>
            <Input value={parentEmail} onChange={(e) => { setParentEmail(e.target.value) }} />
          </Modal>

          {/* <Modal style={{ top: 20 }} width={900} footer={null} title="AiGoLearning Bot" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
            <iframe src="https://web.powerva.microsoft.com/environments/Default-7d1d30a2-a134-4a45-b939-7dabcf1a6674/bots/new_bot_71bd320c090a49579e0d9701f397c86d/webchat" frameBorder="0" style={{ width: '100%', height: '500px' }} />
          </Modal>
  
          <Button type="primary" shape="circle" icon={<RobotOutlined />} onClick={showModal} size="large" style={{ position: 'fixed', bottom: "10px", right: "10px" }}>
  
          </Button> */}

        </div>
        <footer style={{ textAlign: "center" }}>
          Powered by <a href="thinkland.ai" target="_blank">Thinkland.AI</a>
        </footer>
      </Spin>
    </>
  );
};

export default App;
